/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Heading, Text, theme } from "@nordcloud/gnui";
import { InfoCard } from "./InfoCard";

type Props = {
  title?: string;
  caption?: string;
  description?: string;
  onClick?: () => void;
};

export function Card({ title, caption, description, onClick }: Props) {
  return (
    <InfoCard onClick={onClick}>
      {title && (
        <Text size="sm" tag="div">
          {title}
        </Text>
      )}
      {caption && (
        <Heading mt=".25rem" mb="1rem" level={3}>
          {caption}
        </Heading>
      )}
      {description && (
        <Text color={theme.color.text.text01} size="sm" tag="div">
          {description}
        </Text>
      )}
    </InfoCard>
  );
}
